// extracted by mini-css-extract-plugin
export var quillEditor = "_pw-1";
export var variable = "_pw-0";